import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { getTerraceData, TerraceContainerVM, terraceTitles, terraceTypes } from './TerraceContainerVM';
import { ContainerWithSideBar } from '../../common/ContainerWithSideBar/ContainerWithSideBar';
import { Route, Switch, useLocation, useParams, useRouteMatch, Redirect, useHistory } from 'react-router-dom';
import { TerraceDesign } from '../TerraceDesign/TerraceDesign';
import { TerraceInputs } from '../TerraceInputs/TerraceInputs';
import { TerraceTemplate } from '../TerraceTemplate/TerraceTemplate';
import { TerraceStorageCalculation } from '../TerraceStorageCalculation/TerraceStorageCalculation';
import { mdiCalculator, mdiCalculatorVariantOutline, mdiPencilRulerOutline, mdiWaves } from '@mdi/js';
import stores from 'cd-eft/models/Stores';
import './TerraceContainer.scss';
import { DesignContainerVM } from '../../DesignContainer/DesignContainerVM';

const { terraceDesignStore } = stores.AppStore;
interface ITerraceProps {
  addTerraceEdits: any;
}

const TerraceContainerComponent = (props: ITerraceProps) => {
  const { path } = useRouteMatch();
  const { projectId }: any = useParams();
  const { terraceId }: any = useParams();
  const location = useLocation();
  const vmRef = useRef<TerraceContainerVM | null>(null);
  if(!vmRef.current){
    vmRef.current = new TerraceContainerVM();
  }
  const vm = vmRef.current;

  const terraceNavigation = [
    {
      name: 'input',
      title: 'Terrace Inputs',
      icon: mdiWaves,
      link: `/design/${projectId}/terrace/${terraceId}/input`,
    },
    {
      name: 'template',
      title: 'Terrace Template',
      icon: mdiCalculator,
      link: `/design/${projectId}/terrace/${terraceId}/template`,
    },
    {
      name: 'design',
      title: 'Terrace Design',
      icon: mdiPencilRulerOutline,
      link: `/design/${projectId}/terrace/${terraceId}/design`,
    },
    {
      name: 'storage-calculation',
      title: 'Storage Calculation',
      icon: mdiCalculatorVariantOutline,
      link: `/design/${projectId}/terrace/${terraceId}/storage-calculation`,
    },
  ];

  const mapView = DesignContainerVM.mapView;

  useEffect(() => {
    if (terraceId > 0 && mapView) {
      getTerraceData(terraceId, mapView)
    };
  }, [terraceId, mapView]);

  useEffect(()=>{
    vm.getErrors();
    return () => terraceDesignStore.reset();
  }, [])

  return (
    <WrappedTerraceRoute terraceNavigation={terraceNavigation} location={location}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={`/design/${projectId}/terrace/${terraceId}/input`} />
        </Route>
        <Route path={`${path}/design`}>
          <TerraceDesign addTerraceEdits={props.addTerraceEdits} mapView = {mapView}/>
        </Route>
        <Route path={`${path}/input`}>
          <TerraceInputs />
        </Route>
        <Route path={`${path}/template`}>
          <TerraceTemplate />
        </Route>
        <Route path={`${path}/storage-calculation`}>
          <TerraceStorageCalculation />
        </Route>
      </Switch>
    </WrappedTerraceRoute>
  );
};
export const TerraceContainer = observer(TerraceContainerComponent);

type designStep = 'input' | 'design';

const WrappedTerraceRoute = observer(({ children, terraceNavigation, location }) => {
  const step: designStep = location && location.pathname ? location.pathname.split('/').reverse()[0] : '';
  const terraceType = terraceTypes[terraceDesignStore.terraceType];
  const terraceName = terraceDesignStore.terraceDesignObject.alignedFeatureName;
  let designStepTitle = terraceTitles[step];
  if (terraceName) designStepTitle += ` - ${terraceName}`;
  if (terraceType) designStepTitle += ` - ${terraceType}`;

  return (
    <ContainerWithSideBar
      title={designStepTitle}
      navigation={terraceNavigation}
      tab={step}
      collapseMenuClass={'terrace-container'}
      isCollapsed={terraceDesignStore.terraceSidebarIsCollapsed}
      setCollapsed={terraceDesignStore.setCollapsed}
    >
      <div className={`tab-pane-common tab-pane-terrace tab-pane-terrace-${step} tab-pane h-100 active`}>{children}</div>
    </ContainerWithSideBar>
  );
});
